module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/smoking-icon-507e331812e5fd778994abe1477418f6.png";